import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitSalesContactRequestMutationVariables = Types.Exact<{
  project_role: Types.Scalars['String']['input'];
  property_type: Types.Scalars['String']['input'];
  total_size: Types.Scalars['String']['input'];
  location: Types.Scalars['String']['input'];
  notes?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SubmitSalesContactRequestMutation = { __typename?: 'mutation_root', submit_sales_contact_request?: { __typename?: 'SubmitSalesContactRequestOutput', success: boolean } | null };


export const SubmitSalesContactRequestDocument = gql`
    mutation submitSalesContactRequest($project_role: String!, $property_type: String!, $total_size: String!, $location: String!, $notes: String) {
  submit_sales_contact_request(
    project_role: $project_role
    property_type: $property_type
    total_size: $total_size
    location: $location
    notes: $notes
  ) {
    success
  }
}
    `;
export type SubmitSalesContactRequestMutationFn = Apollo.MutationFunction<SubmitSalesContactRequestMutation, SubmitSalesContactRequestMutationVariables>;

/**
 * __useSubmitSalesContactRequestMutation__
 *
 * To run a mutation, you first call `useSubmitSalesContactRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSalesContactRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSalesContactRequestMutation, { data, loading, error }] = useSubmitSalesContactRequestMutation({
 *   variables: {
 *      project_role: // value for 'project_role'
 *      property_type: // value for 'property_type'
 *      total_size: // value for 'total_size'
 *      location: // value for 'location'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useSubmitSalesContactRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSalesContactRequestMutation, SubmitSalesContactRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSalesContactRequestMutation, SubmitSalesContactRequestMutationVariables>(SubmitSalesContactRequestDocument, options);
      }
export type SubmitSalesContactRequestMutationHookResult = ReturnType<typeof useSubmitSalesContactRequestMutation>;
export type SubmitSalesContactRequestMutationResult = Apollo.MutationResult<SubmitSalesContactRequestMutation>;
export type SubmitSalesContactRequestMutationOptions = Apollo.BaseMutationOptions<SubmitSalesContactRequestMutation, SubmitSalesContactRequestMutationVariables>;